// @flow

import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import DownloadButton from './DownloadButton'
import ViewButton from './ViewButton'
import { colors } from '../../style'

import defaultBookCover from './book-cover.png'

const Root = styled.div`
  flex: 1;
  flex-basis: 210px;
  padding: 0 15px;
  margin-bottom: 21px;

  text-align: center;

  &:hover {
    font-weight: bold;
    color: ${colors.red}
  }
`

const CoverWrap = styled.div`
  position: relative;
  width: 155px;
  height: 228px;

  margin: 0 auto 15px auto;
`

const Cover = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const Controls = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  font-family: sans-serif;
  font-weight: normal;
  font-size: .86em;

  color: black;
`

const Title = styled.span`
  display: block;
`

type Props = {
  locale: string,
  onViewClick: Function,
}

class Book extends Component {
  props: Props;

  state = {
    hovered: false
  }

  handleMouseEnter = () => {
    this.setState({ hovered: true })
  }

  handleMouseLeave = () => {
    this.setState({ hovered: false })
  }

  render() {
    const { locale, onViewClick } = this.props
    const { hovered } = this.state

    return (
      <Root
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <CoverWrap>
          {hovered ? (
            <Controls>
              <ViewButton
                onClick={() => onViewClick(locale)}
              />
              <DownloadButton
                href="https://www.zeroone.st"
              />
            </Controls>
          ) : <Cover src={defaultBookCover} />}
        </CoverWrap>
        <Title>
          <FormattedMessage id={`book.locale.${locale}`} />
        </Title>
      </Root>
    )
  }
}

export default Book



// WEBPACK FOOTER //
// ./src/components/Book/Book.js